export const batteryBufferToPercent = (buffer: number) => Math.round(buffer * 100);

export const batteryBufferToDecimal = (buffer: number) => (100 - buffer) / 100;

export const decimalToPercent = (decimalBuffer:number) =>  Math.round(100 - (100 * decimalBuffer));
